import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from "react";
// types
import type { OrchidDriveDirectory } from "contexts/orchid-drive/types";
import type { AttachmentsViewProps, SelectedItem } from "../../..";

type InheritedProps = {
  originFolder: OrchidDriveDirectory | undefined;
  folderPaths: OrchidDriveDirectory[];
  setFolderPaths: Dispatch<SetStateAction<OrchidDriveDirectory[]>>;
  selected: SelectedItem[];
  show: boolean;
  open?: (arg: SelectedItem[]) => void;
  close: () => void;
  onMoveEnd: AttachmentsViewProps["onMoveEnd"];
};

const TreeWidgetContext = createContext<InheritedProps>({
  show: true,
  open: undefined,
  close: () => null,
  originFolder: undefined,
  folderPaths: [],
  setFolderPaths: () => null,
  selected: [],
  onMoveEnd: () => null,
});

type Props = {
  children: ReactNode;
} & InheritedProps;

const TreeWidgetContextProvider = ({ children, ...props }: Props) => (
  <TreeWidgetContext.Provider value={props}>
    {children}
  </TreeWidgetContext.Provider>
);

export default TreeWidgetContextProvider;

export const useTreeWidgetContext = () => useContext(TreeWidgetContext);
